var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoOnboarding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 15,
    r: 5,
    fill: "#CED8E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5857 26.5139C29.6814 26.6869 29.6322 26.9024 29.4739 27.0208C26.9714 28.8919 23.8652 30 20.5002 30C17.1351 30 14.0288 28.8919 11.5263 27.0207C11.368 26.9023 11.3188 26.6868 11.4145 26.5138C12.9981 23.6525 16.4708 21.6667 20.5001 21.6667C24.5294 21.6667 28.0021 23.6526 29.5857 26.5139Z",
    fill: "#CED8E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8333 6.66666H29.67C31.6889 6.66666 32.6984 6.66666 33.4723 7.05333C34.1825 7.40824 34.7584 7.98413 35.1133 8.69441C35.5 9.46826 35.5 10.4777 35.5 12.4967V13.3333M28.8333 33.3333H29.67C31.6889 33.3333 32.6984 33.3333 33.4723 32.9467C34.1825 32.5918 34.7584 32.0159 35.1133 31.3056C35.5 30.5317 35.5 29.5223 35.5 27.5033V26.6667M12.1667 6.66666H11.33C9.31106 6.66666 8.30159 6.66666 7.52775 7.05333C6.81746 7.40824 6.24158 7.98413 5.88667 8.69441C5.5 9.46826 5.5 10.4777 5.5 12.4967V13.3333M12.1667 33.3333H11.33C9.31106 33.3333 8.30159 33.3333 7.52775 32.9467C6.81746 32.5918 6.24158 32.0159 5.88667 31.3056C5.5 30.5317 5.5 29.5223 5.5 27.5033V26.6667",
    stroke: "#CED8E3",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoOnboarding);
export default __webpack_public_path__ + "static/media/ico-onboarding.3b47e3f987698b5e678d7f9e0f93ef99.svg";
export { ForwardRef as ReactComponent };